import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import styles from "../blocks/blocks.module.scss";

export function PageBreakNodeView({ node, selected }: NodeViewProps) {
  return (
    <NodeViewWrapper data-type="page-break-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div className={styles.pageBreakBlock}>
        <div className={styles.pageBreakLine}>
          <span className={styles.pageBreakLabel}>Page Break</span>
        </div>
      </div>
    </NodeViewWrapper>
  );
}
